'use client';
import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgCasperTest = function SvgCasperTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.52 3.978 4.474 6.022l-.994-.991M10.953 3H17M11 6h10M6.52 10.978l-2.046 2.044-.994-.991M10.953 10H17M11 13h10M21 20H10.953M21 17H11M5 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    vectorEffect: "non-scaling-stroke"
  })));
};

export { SvgCasperTest as default };
//# sourceMappingURL=casper-test.svg.js.map
